import ErrorDetailsDialog from './ErrorDetailsDialog';

export default ErrorDetailsDialog;
